import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { AccessService } from '../service/access.service';

export const authGuard = () => {
  const _authService = inject(AuthService);
  const _accessService = inject(AccessService);
  const _router = inject(Router);

  if (_authService.isAuthenticated()) {
    return true;
  }else{
    _accessService.removeAccess().subscribe(()=>{
      _router.navigate(
        ['/auth/login']
      );  
    
    });

    return false;
  }

};